import { SET_FOLDERS, SET_SELECTED_FOLDER } from '../actions/types.js';

const initialState = {
  selectedFolder: {
    id: null,
    name: '',
    user_id: '',
    company_id: '',
    created_at: '',
    updated_at: ''
  },
  all: []
}

export function folder(state = initialState, action = {}) {
  switch (action.type) {
    case SET_FOLDERS:
      return Object.assign({}, state, { all: action.folders });
    case SET_SELECTED_FOLDER:
      return Object.assign({}, state, { selectedFolder: action.folder });
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/folder.js